import { render, staticRenderFns } from "./VentanaOperacionesEditarLiquidacion.vue?vue&type=template&id=2867b6e0"
import script from "./VentanaOperacionesEditarLiquidacion.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesEditarLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports